import { z } from 'zod'

import noLeadingSpaces from '../../utilities/noLeadingSpaces'

export const loginSchema = z.object({
  email: z
    .string()
    .min(1, { message: 'Required' })
    .email({ message: 'Enter a valid email' }),
  password: z
    .string()
    .min(1, { message: 'Password field cannot be empty' })
    .refine(noLeadingSpaces, {
      message: 'Leading spaces are not allowed',
    }),
})

export type LoginSchema = z.infer<typeof loginSchema>
